import React from 'react';

const AgentNav = ({ model, onNavClick, selectedSection }) => {

    const pendingTypes = import.meta.env.VITE_PENDING_TYPES || '';
    const bobTypes = import.meta.env.VITE_BOB_TYPES || '';

    const navButton = (id, label, condition = true) =>
        condition && (
            <span
                className={`nav-button ${selectedSection === id ? 'active' : ''}`}
                onClick={() => onNavClick(id)}
            >
                {label}
            </span>
        );

    return (
        <div className="nav-buttons-container">
            <div className="nav-buttons d-md-block buttons-wrapper">
                {navButton('agent-values-container', 'Agent Values')}
                {navButton('pending-business-container', 'Pending Business', Boolean(pendingTypes))}
                {navButton('current-business-container', 'Book of Business', Boolean(bobTypes))}
                {navButton('commission-detail-container', 'Commission Detail')}
                {navButton('agent-statements-container', 'Commission Statements')}
                {navButton('agent-1099-container', '1099s')}
                {navButton('balance-history-container', 'Balance History')}
                {navButton('agent-serviceForms-container', 'Agent Materials')}
                {/*{navButton('upload-form-container', 'Upload Forms')}*/}
            </div>
        </div>
    );
};

export default AgentNav;
